export function sortCreatedAtFromNewest<
  T extends { createdAt?: string | null }
>(collections: T[]): T[] {
  return collections?.slice().sort((a, b) => {
    const dateA = new Date(a.createdAt as string).getTime();
    const dateB = new Date(b.createdAt as string).getTime();
    return dateB - dateA;
  });
}
